import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { ContactUs } from 'features/ContactUs'
import Script from 'next/script'

export default function User() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('contact-us:page-title')}</title>
        <meta name="title" content={t('contact-us:meta-title')} />
        <meta name="description" content={t('contact-us:meta-description')} />
      </Head>
      <main>
        <ContactUs />
      </main>
    </div>
  )
}
